module.exports = __webpack_public_path__ + "static/media/companyLogo.5040bc44.png";